const getters = {
    appName:state => state.app.appName,
	systemInfo: state => state.app.systemInfo,
	appVerCode:state => state.app.appVerCode,
	appVerName:state => state.app.appVerName,
	baseUrl:state => state.app.baseUrl,
	cityCode:state => state.app.cityCode,
	baseImgUrl:state => state.app.baseImgUrl,
	openId:state => state.user.openId,
	userInfo:state => state.user.userInfo,
    token: state => state.user.token,
    openId: state => state.user.openId,
    avatar: state => state.user.avatar,
    verifyLogin: state => state.app.verifyLogin,
    verifyImg: state => state.app.verifyImg,
    name: state => state.user.name,
    appVerCode:state => state.app.appVerCode,
	appVerName:state => state.app.appVerName,
}
export default getters